import { render } from "./WorkBenchMain.vue?vue&type=template&id=077d7a36"
import script from "./WorkBenchMain.vue?vue&type=script&lang=js"
export * from "./WorkBenchMain.vue?vue&type=script&lang=js"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__